<div class="row align-items-center" (click)="closeDropDown()">
  <div class="col-md-12">

    <div #menu class="d-flex justify-content-between location-selector-form"
      [ngClass]="{'disableSelector':selectorDisabled,'location-selector-focus' : selectorOpened}" id="ddlLocationy"
      (click)="locationClick()" (click)="$event.stopPropagation()">
      <div>
        <span *ngIf="selectorDisabled && selectedUsers.length<1">
          {{selectedUserName}}
        </span>
        <span *ngIf="!selectorDisabled && selectedUsers.length<1">
          {{'_General_Select_Text_' | translate }}
        </span>

        <kendo-chip *ngFor="let selectedUser of selectedUsers.slice(0,3)" [label]="selectedUser.name" [removable]="true"
          removeIcon="k-icon k-i-close" (remove)="onRemove(selectedUser);">
        </kendo-chip>
      </div>
      <div class="d-flex flex-column align-items-center ms-1">
        <em class="fas fa-chevron-down"></em>
        <span *ngIf="(selectedUsers.length || 0) > 3">+{{(selectedUsers.length || 0) - 3}}
        </span>
      </div>
    </div>
    <div class="location-tree-wrapper p-2" *ngIf="selectorOpened" (click)="$event.stopPropagation()">
      <user-multi-selector-tree-view [locations]="locations" [expandedKeys]="expandedKeys" [filterTerm]="searchKeyWord"
        [selectedUserId]="selectedUserId" [checkedKeys]="checkedKeys" (onChange)="handleChange($event)"
        (closeEvent)="onItemSelected($event)" [dispatchStateEvent]="dispatchStateEvent">
      </user-multi-selector-tree-view>
    </div>
  </div>
</div>